// extracted by mini-css-extract-plugin
export default {"wrapper":"src-views-debug-DebugSDSBoxes-DebugSDSBoxes__wrapper--uWU7y"};